import { Periods, MetricDataPoint } from 'cio/utils/metrics/common';
import { SegmentMembershipMetric } from 'cio/utils/metrics/models/segment-membership-metric';
import moment from 'moment-timezone';
import { TimeRange } from 'cio/utils/time';

function valuesToDataPoints(values: number[], timestamps: number[]) {
  return (values ?? []).map((value: number, i: number) => ({
    x: timestamps[i],
    y: value,
  }));
}

export function deserialize(
  data: any,
  entityId: number | string,
  range: TimeRange | null,
  meta?: { environmentId?: number | string; campaignId?: number | string },
): null | SegmentMembershipMetric {
  if (!data.membership_metric) {
    return null;
  }

  let result = data.membership_metric;

  let membershipData: Record<string, MetricDataPoint[]> = {
    total: [],
    entered: [],
    left: [],
  };

  let start = moment.unix(result.start);

  let timestamps: number[] = [];

  if (result.resolution === Periods.DAYS) {
    timestamps = [...new Array(result.total?.length || 0)].map(
      (_, i: number) => moment(start).utc().add(i, 'days').startOf('day').unix() * 1000,
    );
  }

  if (result.resolution === Periods.WEEKS) {
    timestamps = [...new Array(result.total?.length || 0)].map(
      (_, i: number) => moment(start).utc().add(i, 'weeks').startOf('isoWeek').unix() * 1000,
    );
  }

  if (result.resolution === Periods.MONTHS) {
    timestamps = [...new Array(result.total?.length || 0)].map(
      (_, i: number) => moment(start).utc().add(i, 'months').startOf('month').unix() * 1000,
    );
  }

  membershipData.total = valuesToDataPoints(result.total, timestamps);
  membershipData.entered = valuesToDataPoints(result.entered, timestamps);
  membershipData.left = valuesToDataPoints(result.left, timestamps);

  return new SegmentMembershipMetric({
    entityId,
    range,
    result,
    membershipData,
    meta,
  });
}
